import React from "react"
import "./ChatIntro.css"

export default (props) => {
   return (
      <div className="chatintro">
         <img
            src="https://c4.wallpaperflare.com/wallpaper/173/418/373/app-chat-messenger-whatsapp-wallpaper-preview.jpg"
            alt="wpp-img"
         />
         <h1>Mantenha seu celular conectado</h1>
         <h2>
            O WhatsApp conecta ao seu telefone para sincronizar suas menssagens.
         </h2>
         <h2>
            Para reduxir o uso de dados, conecte seu telefone a uma rede Wi-Fi
         </h2>
      </div>
   )
}
